module.exports = __webpack_public_path__ + "img/8つのメリット.f1f17713.png";